// src/components/GroupHeader.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getTextColor, spacing, typography } from '../themes';

const GroupTitle = styled(Typography)(({ theme }) => ({
  fontSize: typography.fontSize.xs,
  fontWeight: typography.fontWeight.medium,
  textTransform: 'uppercase',
  letterSpacing: typography.letterSpacing.wide,
  color: getTextColor(theme, 'groupHeader'),
  padding: theme.spacing(spacing.base, spacing.lg, spacing.sm, spacing.lg),
  marginTop: theme.spacing(spacing.base),
}));

const GroupHeader = ({ title }) => {
  return (
    <Box>
      <GroupTitle>{title}</GroupTitle>
    </Box>
  );
};

export default GroupHeader;